
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection'
import TemplateShowOrder from 'components/organisms/TemplateShowOrder/TemplateShowOrder'
import Layout from 'layout/Layout'
import { useParams } from 'react-router-dom'
import { ButtonDropdown } from 'components/molecules/ButtonDropdown/ButtonDropdown'

export default function ShowTemplatePage() {
    const { orderId } = useParams()
    const orderIdNumber = Number(orderId)

    return (
        <Layout>
            <HeaderPageSection
                title={`Orden # ${orderId}`}
                subtitle="Visualizar información de ordenes asignadas, disponibles y otros."
            >
                <ButtonDropdown
                                                title={'Cargar orden'}
                                                options={[
                                                    {
                                                        title: 'Sin criterios',
                                                        path: '/orders/create/no-template',
                                                    },
                                                    {
                                                        title: 'Con criterios',
                                                        path: '/orders/create/template',
                                                    },
                                                ]}
                                                color={'primary'}
                                            />
            </HeaderPageSection>
            <TemplateShowOrder orderId={orderIdNumber} />
        </Layout>
    )
}
